import { LOCAL_STORAGE } from "../components/utils/constants";
let ClientQuicksightURL = () => {
    let client = LOCAL_STORAGE.customerNo

    switch (client) {
        case "1545":
            return {
                "MIS_REPORT": '5b5a6d59-82a1-4bf3-b120-b6b3420590e5',
            }
        default:
            return null
    }
}

export default ClientQuicksightURL();